export default "__VITE_ASSET__C0ba4m47__"